import { forwardRef } from "react";
import { NativeSelect, NativeSelectProps, OutlinedInput } from "@mui/material";
import { IconCaret } from "src/components/icons-mui/caret";

export interface IWfSelectProps extends NativeSelectProps {}

const CustomIconCaret = () => (
    <IconCaret
        sx={{
            width: "24px",
            height: "24px",
            position: "absolute",
            right: "16px",
            pointerEvents: "none",
            userSelect: "none",
        }}
    />
);

export const WfNativeSelect = forwardRef<HTMLSelectElement, IWfSelectProps>(({ children, ...selectProps }, ref) => {
    return (
        <NativeSelect
            input={
                <OutlinedInput
                    slotProps={{
                        input: {
                            sx: {
                                position: "relative",
                                paddingRight: theme => `${theme.spacing(6)} !important`,
                                backgroundColor: "white",
                            },
                        },
                    }}
                />
            }
            ref={ref}
            sx={{
                "& option": {
                    backgroundColor: "white !important",
                },
                "& option[value='']": {
                    backgroundColor: "white !important",
                    color: "gray.500 !important",
                },
            }}
            IconComponent={CustomIconCaret}
            {...selectProps}
        >
            {children}
        </NativeSelect>
    );
});

WfNativeSelect.displayName = "WfNativeSelect";
